module.exports = __webpack_public_path__ + "img/服务榜.e22f243f.png";